import React from "react";
import { ProductFormValues } from "../../../types/product/ProductFormValues";
import { useProduct } from "../../../hooks/useProduct";
import Checkbox from "../../Forms/Input/Checkbox";

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductSpecialConditionsSection: React.FC<Props> = ({ form, onChange }) => {
  const { formErrors } = useProduct();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Checkbox
        label="Requiere Cadena de Frío"
        checked={!!form.coldChain}
        onChange={() => onChange("coldChain", !form.coldChain)}
      />
      {formErrors.coldChain && (
        <p className="text-sm text-red dark:text-red col-span-2">
          {formErrors.coldChain}
        </p>
      )}

      <Checkbox
        label="Sensible a Humedad"
        checked={!!form.humiditySensitive}
        onChange={() => onChange("humiditySensitive", !form.humiditySensitive)}
      />
      {formErrors.humiditySensitive && (
        <p className="text-sm text-red dark:text-red col-span-2">
          {formErrors.humiditySensitive}
        </p>
      )}
    </div>
  );
};

export default ProductSpecialConditionsSection;
